import Model, { attr } from '@ember-data/model';

export type ChannelAccountType = 'booking_dot_com';

export interface IChannelAccountData {
  company_name: string;
  legal_contact_email: string;
  legal_contact_name: string;
  legal_contact_phone_number?: string;
  legal_name?: string;
  preferred_language?: string;
  city?: string;
  country?: string;
  street?: string;
  zipcode?: string;
}

export default class ChannelAccountModel extends Model {
  @attr('string') type!: ChannelAccountType;
  @attr('object') data!: IChannelAccountData;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'channel-account': ChannelAccountModel;
  }
}
